import React, { useState, useCallback, useEffect } from 'react';

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

const UPDATE_ALWAYS = 2;
const UPDATE_ON_OBJECT = 1;
// const UPDATE_NEVER = 0;

function useAction(action, props, options) {
  const [{ getId, getObject }] = useState(() => {
    const { objectProp = 'object' } = options;
    return {
      getId: options.getId || (o => o.id),
      getObject: options.getObject || (pps => pps[objectProp]),
    };
  });
  const object = getObject(props);

  const propCB = action.callbackProp ? props[action.callbackProp] : null;
  if (action.callbackProp && !propCB) {
    console.error('Missing action callback ', action.callbackProp);
  }
  const [url, history, location] = action.getLink
    ? [action.getLink(object, props), props.history, props.location] : [];

  const onClick = useCallback((e) => {
    if (url) {
      if (!action.download) {
        e.preventDefault();
        history.push(url, { referrer: location });
      }
    } else if (action.onClick) {
      if (action.useEvent) {
        action.onClick(e, object, props);
      } else {
        action.onClick(object, props);
      }
    } else if (propCB) {
      if (action.useEvent) {
        propCB(e, object, props);
      } else {
        propCB(object, props);
      }
    }
  }, [propCB, action.onClick, url, history, location, object]);

  const { update = UPDATE_ON_OBJECT } = action;

  const computeState = useCallback((o) => {
    return {
      tooltip: action.getTooltip ? action.getTooltip(o) : action.tooltip,
      Icon: action.getIcon ? action.getIcon(o) : (action.icon || (action.download && DownloadIcon)),
      label: action.getLabel ? action.getLabel(o) : action.label,
      ariaLabel: action.getAriaLabel ? action.getAriaLabel(o) : action.ariaLabel,
      actionId: action.getId ? action.getId(o) : (action.idPrefix && `${action.idPrefix}${getId(o)}` || `${action.name}-${getId(o)}`),
      disabled: action.isDisabled ? action.isDisabled(o) : undefined,
      onClick,
    };
  }, [action, onClick]);
  const [actionState, setActionState] = useState(() => (update !== UPDATE_ALWAYS ? computeState(object) : {}));

  useEffect(() => {
    if (update === UPDATE_ON_OBJECT) {
      const newState = computeState(object);
      if ((newState.tooltip !== actionState.tooltip)
          || (newState.Icon !== actionState.Icon)
          || (newState.label !== actionState.label)
          || (newState.ariaLabel !== actionState.ariaLabel)
          || (newState.actionId !== actionState.actionId)
          || (newState.onClick !== actionState.onClick)) {
        setActionState(newState, props); // in this context, props is only used for getting the static click callback
      }
    }
  }, [action, object, computeState]);

  const newState = update === UPDATE_ALWAYS ? computeState(object, props) : actionState;
  return url ? { ...newState, url } : newState;
}

export { useAction as default, DownloadIcon };
